import { render, staticRenderFns } from "./ot-create-claim-wizard.vue?vue&type=template&id=045bd15c&scoped=true&"
import script from "./ot-create-claim-wizard.vue?vue&type=script&lang=ts&"
export * from "./ot-create-claim-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./ot-create-claim-wizard.vue?vue&type=style&index=0&id=045bd15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045bd15c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VForm,VMenu})
